module.exports = __webpack_public_path__ + "img/海洋灾害.e125ef7f.png";